/**
 * Do not edit directly
 * Generated on Thu, 17 Feb 2022 11:35:15 GMT
 */
export const buttonSizeLargeFontSize = "1.125rem";
export const buttonSizeLargeLineHeight = "1.75rem";
export const buttonSizeLargePadding = "0.5rem 1rem";
export const buttonSizeMediumFontSize = "1rem";
export const buttonSizeMediumLineHeight = "1.5rem";
export const buttonSizeMediumPadding = "0.25rem calc(0.25rem * 3)";
export const buttonSizeSmallFontSize = "0.875rem";
export const buttonSizeSmallLineHeight = "1.25rem";
export const buttonSizeSmallPadding = "calc(0.25rem / 2) 0.5rem";
export const buttonSizeDefaultFontSize = "1rem";
export const buttonSizeDefaultLineHeight = "1.5rem";
export const buttonSizeDefaultPadding = "0.25rem calc(0.25rem * 3)";
export const buttonTypePrimaryDefaultBorderColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypePrimaryDefaultBorderColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypePrimaryDefaultBackgroundColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypePrimaryDefaultBackgroundColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypePrimaryDefaultTextColorDark = "hsla(40, 3%, 100%, 1)";
export const buttonTypePrimaryDefaultTextColorLight = "hsla(223, 67%, 18%, 1)";
export const buttonTypePrimaryHoverBorderColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypePrimaryHoverBorderColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypePrimaryHoverBackgroundColorDark = "hsla(218, 100%, 20%, 1)";
export const buttonTypePrimaryHoverBackgroundColorLight = "hsla(139, 100%, 70%, 1)";
export const buttonTypePrimaryHoverTextColorDark = "hsla(40, 3%, 100%, 1)";
export const buttonTypePrimaryHoverTextColorLight = "hsla(223, 67%, 18%, 1)";
export const buttonTypePrimaryActiveBorderColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypePrimaryActiveBorderColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypePrimaryActiveBackgroundColorDark = "hsla(218, 100%, 35%, 1)";
export const buttonTypePrimaryActiveBackgroundColorLight = "hsla(139, 100%, 85%, 1)";
export const buttonTypePrimaryActiveTextColorDark = "hsla(40, 3%, 100%, 1)";
export const buttonTypePrimaryActiveTextColorLight = "hsla(223, 67%, 18%, 1)";
export const buttonTypePrimaryFocusOutline = "0.25rem solid hsla(196, 100%, 43%, 1)";
export const buttonTypeSecondaryDefaultBorderColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeSecondaryDefaultBorderColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeSecondaryDefaultBackgroundColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypeSecondaryDefaultBackgroundColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypeSecondaryDefaultTextColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeSecondaryDefaultTextColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeSecondaryHoverBorderColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeSecondaryHoverBorderColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeSecondaryHoverBackgroundColorDark = "hsla(196, 74%, 90%, 1)";
export const buttonTypeSecondaryHoverBackgroundColorLight = "hsla(218, 100%, 25%, 1)";
export const buttonTypeSecondaryHoverTextColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeSecondaryHoverTextColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeSecondaryActiveBorderColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeSecondaryActiveBorderColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeSecondaryActiveBackgroundColorDark = "hsla(196, 74%, 95%, 1)";
export const buttonTypeSecondaryActiveBackgroundColorLight = "hsla(218, 100%, 35%, 1)";
export const buttonTypeSecondaryActiveTextColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeSecondaryActiveTextColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeSecondaryFocusOutline = "0.25rem solid hsla(196, 100%, 43%, 1)";
export const buttonTypeTertiaryDefaultBorderColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryDefaultBorderColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryDefaultBackgroundColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryDefaultBackgroundColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryDefaultTextColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeTertiaryDefaultTextColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeTertiaryHoverBorderColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryHoverBorderColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryHoverBackgroundColorDark = "hsla(196, 74%, 90%, 1)";
export const buttonTypeTertiaryHoverBackgroundColorLight = "hsla(218, 100%, 25%, 1)";
export const buttonTypeTertiaryHoverTextColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeTertiaryHoverTextColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeTertiaryActiveBorderColorDark = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryActiveBorderColorLight = "hsla(0, 0%, 0%, 0)";
export const buttonTypeTertiaryActiveBackgroundColorDark = "hsla(196, 74%, 95%, 1)";
export const buttonTypeTertiaryActiveBackgroundColorLight = "hsla(218, 100%, 35%, 1)";
export const buttonTypeTertiaryActiveTextColorDark = "hsla(218, 100%, 28%, 1)";
export const buttonTypeTertiaryActiveTextColorLight = "hsla(139, 100%, 78%, 1)";
export const buttonTypeTertiaryFocusOutline = "0.25rem solid hsla(196, 100%, 43%, 1)";
export const buttonDisabledCursor = "default";
export const buttonDisabledOpacity = "50%";
export const buttonBorderStyle = "solid";
export const buttonBorderWidth = "calc(0.125rem / 2)";
export const buttonFontFamily = "'Avenir Next', Arial, sans-serif";
export const buttonFontSize = "1rem";
export const buttonLineHeight = "1.5rem";
export const buttonFontWeight = "500";
export const buttonPadding = "calc(0.25rem * 1.5) calc(0.25rem * 3)";
export const buttonTransition = "all 0.15s ease-in-out";
export const buttonCursor = "pointer";
